export const TypingIndicator = () => (
  <div className='flex items-center gap-2'>
    <div className='flex flex-shrink-0 items-center justify-center rounded-full p-1.5'>
      <img
        src='/images/orange-AI.svg'
        alt='AI'
        width={25}
        height={25}
        className='flex-shrink-0'
      />
    </div>
    <div className='rounded-lg border border-[#FF6600] px-4 py-2 text-gray-800'>
      <div className='flex items-center gap-1'>
        <div
          className='h-2 w-2 animate-bounce rounded-full bg-gray-400'
          style={{ animationDelay: '0ms' }}
        ></div>
        <div
          className='h-2 w-2 animate-bounce rounded-full bg-gray-400'
          style={{ animationDelay: '150ms' }}
        ></div>
        <div
          className='h-2 w-2 animate-bounce rounded-full bg-gray-400'
          style={{ animationDelay: '300ms' }}
        ></div>
      </div>
    </div>
  </div>
)
